import axios from 'axios'
import { PROJECT_ID, XLURLS } from '@/common/config'
import JwtDecode from 'jwt-decode'

const state = {
  token: localStorage.getItem('xltoken'),
  isLoading: !!localStorage.getItem('xltoken')
}

const getters = {
  currentUser: (state) => {
    var user = null

    if (state.token) {
      try {
        user = JwtDecode(state.token)
      } catch (err) {
        user = null
        // console.error(err)
      }
    }

    return user
  },
  isAuthenticated: (state) => !!state.token,
  isAdmin: (state, getters) => {
    var user = getters.currentUser

    if (user) {
      return user.groups.filter(group => group.name === 'admin').length > 0
    }

    return false
  },
  isLoading: (state) => state.isLoading,
  token: (state) => state.token
}

const actions = {
  auth: ({ commit }) => {
    commit('setLoading', true)

    var url = new URL(document.location.href)
    var obj = {}

    for (var pair of url.searchParams.entries()) {
      obj[pair[0]] = pair[1].trim()
    }

    if (obj.token) {
      try {
        JwtDecode(obj.token)
      } catch (err) {
        obj = null
        // console.error(err)
      }
    }

    commit('setLoading', false)

    if (obj) {
      commit('set', obj)

      return true
    }

    return false
  },
  process: async ({ commit }, data) => {
    commit('setLoading', true)

    var skipSetLoading = false
    var errText = null

    try {
      var params = {
        url: XLURLS[data.type].url,
        method: XLURLS[data.type].method,
        headers: { 'Content-Type': 'application/json' },
        params: {
          login_url: data.callback,
          with_logout: 0,
          projectId: PROJECT_ID
        },
        data: data.payload
      }

      var res = await axios(params)

      if (res.status !== 204 && XLURLS[data.type].result) {
        var redirectUrl = XLURLS[data.type].result.reduce((xs, x) => (xs && xs[x]) ? xs[x] : null, res.data)

        if (redirectUrl) {
          document.location.href = redirectUrl
          skipSetLoading = true
        }
      }

      if (!skipSetLoading) {
        commit('setLoading', false)
      }

      return res
    } catch (error) {
      errText = ['response', 'data', 'error', 'description'].reduce((xs, x) => (xs && xs[x]) ? xs[x] : null, error)

      if (!errText) {
        // console.error(error)

        errText = `${error.name}: ${error.message}`
      }

      commit('setLoading', false)

      throw new Error(errText)
    }
  },
  logout: ({ commit }) => {
    commit('purge')
  },
  check: ({ commit }) => {
    if (state.token) {
      // returnif (obj.token) {
      //   try {
      //     obj.user = JwtDecode(obj.token)
      //   } catch (err) {
      //     obj = null
      //     // console.error(err)
      //   }
      // }
      return
    }

    commit('purge')
  }
}

const mutations = {
  setLoading: (state, value) => {
    state.isLoading = !!value
  },
  set: (state, data) => {
    state.token = data.token
    // state.user = data.user

    localStorage.setItem('xltoken', data.token)
  },
  purge: (state) => {
    // console.log('PURGE CALLED')
    state.token = null
    // state.user = null
    state.isLoading = false

    localStorage.removeItem('xltoken')
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
